<template>
  <div>
    <el-main>

      <div>
        <el-form ref="formInline" :inline="true" :model="formInline" class="demo-form-inline"  style="float: left;text-align: left;padding-top:10px ;">
          <el-form-item label="问题筛选" prop="type">
             <el-input  v-model="qaSelect" placeholder="请输入问题关键字" maxlength="50" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button  type="primary" icon="el-icon-search" @click="queryStr"></el-button>
          </el-form-item>
        </el-form>
        <div style="padding: 10px 0px;text-align: left;float: right">
          <el-button type="primary" @click="addQuestion">新增</el-button>
<!--          <el-button type="primary" @click="openAdd()">导入</el-button>-->
        </div>
      </div>
    <el-table id="dataTable" :data="dataList" :border="border" :height="tableHeight"
              style="height:auto;" :header-cell-style="tableHeaderColor">
<!--      <el-table-column header-align="center" align="center"  prop="questionId" label="编号" width="" ></el-table-column>-->
      <el-table-column header-align="center" label="问题" width="400" show-overflow-tooltip>
        <template slot-scope="scope">
          <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" v-html="scope.row.question "></div>
        </template>
      </el-table-column>
      <el-table-column header-align="center" label="答案" width="800" show-overflow-tooltip>
        <template slot-scope="scope">
            <div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" v-html="scope.row.answer "></div>
        </template>
      </el-table-column>
      <el-table-column header-align="center" prop="createTime" label="创建时间" width="" ></el-table-column>
      <el-table-column header-align="center" align="center" label="操作" width="" >
        <template slot-scope="scope">
<!--          <el-button size="mini" type="primary" style="color: #FFFFFF"  @click="changeQaInfo(scope.row)">修改</el-button>-->
          <el-button size="mini" class="grey"  @click="open(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top:40px;right:10px; width:100%; text-align:right;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalPageNum">
      </el-pagination>
    </div>
    <!-- 修改信息弹窗-->

    </el-main>
  </div>
</template>

<script>
// import $ from 'jquery'
import { getQAList, updateQA} from '@/api/common'
export default {
  name: 'personsend',
  data () {
    return {
      token: sessionStorage.getItem('token'),
      fileList: [],
      currentPage: 1,
      totalPageNum: 0,
      choiceformList: [],
      nameList: [],
      dataList: [],
      qaSelect: '',
      tableHeight: '200px',
      border: false,
      selectedRowId: '',
      colShow: false,
      total: 0,
      dialogFormVisible: false,
      changedialogFormVisible: false,
      closeOnClick: false,
      showClose: false,
      pageSize: 10,
      pageNow: 0,
      sQuestion: '',
      formInline: {
        user: '',
        type: '',
        date: ''
      },
      form: {},
      changeinfoform: {
        c_question: '',
        c_answer: '',
        c_type: ''
      },
      dialogform: {
        region: ''
      },
      question: '',
      qstypes: [{
        labelId: '',
        labelName: '全部'
      }],
      formLabelWidth: '120px',
      innerVisible: false,
      childtype1: '',
      childtype2: '',
      innertypename: '',
      value: '',
      textarea: '',
      id: '',
      qaType: '',
      userId: '15678902834',
      selectrow: '',
      innerTypeSelect: '',
      changevalue: ''
    }
  },
  created () {
    this.userId = localStorage.getItem('userId')
    this.tableHeight = window.innerHeight - 352 + 'px'
    window.onresize = () => {
      return (() => {
        this.tableHeight = window.innerHeight - 352 + 'px'
      })()
    }
  },
  mounted: function () {
    let params = {
      pageSize: this.pageSize,
      pageNow: this.pageNow,
      userId: this.userId
    }
    this.queryStr(params)
    this.dialogVisible = false
  },
  methods: {
    success () {
      this.pageNow = 0
      let params = {
        pageSize: this.pageSize,
        pageNow: this.pageNow,
        qaSelect: this.qaSelect,
        isHotQuestion: 'true',
        userId: this.userId
      }
      this.currentPage = 1
      this.value = ''
      this.getQAList(params)
    },
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePreview (file) {
      console.log(file)
    },
    changeQaInfo (row) {
      console.log('选中的:::' + JSON.stringify(row))
      this.changedialogFormVisible = true
      this.selectrow = row
      this.changeinfoform.c_question = row.question
      this.changeinfoform.c_answer = row.answer
      this.changevalue = row.typeFirst
      this.innerTypeSelect = row.typeFirst
    },
    changeDialog () {
      this.updateQA()
    },
    addQuestion () {
      // this.$router.push({path: '/personsend/2'})

      this.$router.push({path: '/personsend', query: { id: '2' }})
    },
    /* 点击切换先去修改分配状态
    * status 1 是自动分配
    * status 0是全员分配 */
    tableHeaderColor ({ row, column, rowIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #f0f0f0;'
      }
    },
    selectTrigger (val) {
    },
    uuid () { // 生成uid
      let s = []
      let hexDigits = '0123456789abcdef'
      for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
      }
      s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = '-'
      let uuid = s.join('')
      return uuid
    },
    open (row) {
      this.$confirm('此操作将删除该热点问题, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delQA(row)
      }).catch(() => {
        this.$notify({
          title: '提示',
          message: '已取消删除',
          type: 'warning'
        })
      })
    },
    // 删除问答
    delQA (row) {
      console.log('删除：' + row.id)
      let url = '/updateQA'
      let params = {
        id: row.id,
        question: row.question,
        answer: row.answer,
        isHotQuestion: 'false',
        typeFirst: row.typeFirst,
        quesFrom: row.quesFrom,
        quesType: row.quesType,
        questionId: row.questionId,
        createTime: row.createTime
      }
      updateQA(url, params).then(response => {
        // console.log('删除几口' + JSON.stringify(response))
        if (response.data.ret === 1) {
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success'
          })
          this.value = ''
          let params = {
            pageSize: this.pageSize,
            pageNow: this.pageNow,
            qaSelect: this.qaSelect,
            isHotQuestion: 'true',
            userId: this.userId
          }
          this.getQAList(params)
        }
      }).catch(response => {
        this.$notify({
          title: '提示',
          message: '删除失败，请重试',
          type: 'warning'
        })
      })
    },
    queryStr (evt) {
      let target = evt.target
      if (target) {
        // 根据button组件内容 里面包括一个span标签，如果设置icon，则还包括一个i标签，其他情况请自行观察。
        // 所以，在我们点击到button组件上的文字也就是span标签上时，直接执行e.target.blur()不会生效，所以要加一层判断。
        if (target.nodeName) {
          if (target.nodeName === 'SPAN' || target.nodeName === 'I') {
            target = evt.target.parentNode
          }
        }
        target.blur()
      }

      let e = this.qaSelect
      this.pageNow = 0
      this.currentPage = 1
      let params = ''
      if (e === '') {
        params = {
          pageSize: this.pageSize,
          pageNow: this.pageNow,
          userId: this.userId,
          isHotQuestion: 'true'
        }
      } else {
        params = {
          pageSize: this.pageSize,
          pageNow: this.pageNow,
          qaSelect: e,
          isHotQuestion: 'true',
          userId: this.userId
        }
      }
      this.getQAList(params)
    },
    // 获取问答列表
    getQAList: function (params) {
      let url = '/selectQaList'
      getQAList(url, params).then(response => {
        // console.log('获取人员列表' + JSON.stringify(response))
        if (response.data.ret === 1) {
          this.dataList = response.data.content.qaList
          this.totalPageNum = response.data.content.elementsCount
        }
      }).catch(response => {
        this.totalPageNum = 0
        this.$notify({
          title: '提示',
          message: '获取问答列表失败，请刷新重试',
          type: 'warning'
        })
      })
    },
    handleSizeChange (pageSize) {
      console.log('handleSizeChange')
      this.pageSize = pageSize
      this.dataList = []
      let params = {}
      if (this.qaSelect === '') {
        params = {
          pageSize: pageSize,
          pageNow: this.pageNow,
          userId: this.userId,
          isHotQuestion: 'true'
        }
      } else {
        params = {
          pageSize: pageSize,
          pageNow: this.pageNow,
          qaSelect: this.qaSelect,
          userId: this.userId,
          isHotQuestion: 'true'
        }
      }

      this.getQAList(params)
      console.log(`每页 ${pageSize} 条`)
    },
    handleCurrentChange (currentPage) {
      console.info('handleCurrentChange')
      this.pageNow = currentPage - 1
      this.dataList = []
      let params = {}
      if (this.qaSelect === '') {
        params = {
          pageSize: this.pageSize,
          pageNow: currentPage - 1,
          userId: this.userId,
          isHotQuestion: 'true'
        }
      } else {
        params = {
          pageSize: this.pageSize,
          pageNow: currentPage - 1,
          qaSelect: this.qaSelect,
          userId: this.userId,
          isHotQuestion: 'true'
        }
      }

      this.getQAList(params)
      console.log(`当前页: ${currentPage - 1}`)
    },
    showExceptionMessage: function () {
      this.$notify({
        title: '提示',
        message: '系统异常：请联系管理员！',
        type: 'error'
      })
    }

  }
}
</script>
<style scoped>
  .activecolor{
    background-color: #67c23a !important;
    color: #fff;
    width: 67px;
    text-align: center;
  }
  .grey{
    background-color: gainsboro;
    width: 67px;
    text-align: center;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// src/views/services/hotquestion.vue